const ANDROID_IAB_ERROR = 'Error invoking postMessage: Java object is gone';
const ANDROID_IAB_SOURCE = 'iabjs://navigation_performance_logger_android';

const filterInjectedAndroidIabError = (event) => {
    const exceptions = event?.exception?.values;
    const isInjectedAndroidIabError = Array.isArray(exceptions) && exceptions.some((exception) => (
        exception?.value === ANDROID_IAB_ERROR
        && Array.isArray(exception?.stacktrace?.frames)
        && exception.stacktrace.frames.some((frame) => frame?.filename === ANDROID_IAB_SOURCE)
    ));

    return isInjectedAndroidIabError ? null : event;
};

export default filterInjectedAndroidIabError;
